import { Time } from "./time";

export class Address {
	private address: string = "";
	private cryptocoin_id: string = "";
	private generated_at: Time = new Time();
	private last_updated: Time = new Time();
	private name: string = "";
	private enabled: boolean = true;
	private validity_remaining: number = -1;
	private wallet_id: string = "";

	// Ripple desitnation Tag
	private destination_tag: string = "";

	public getDestinationTag(): string {
		return this.destination_tag;
	}

	public setDestinationTag(tag: string): void {
		this.destination_tag = tag;
	}
	public getAddress(): string {
		return this.address;
	}

	public getGeneratedAt(): Time {
		return this.generated_at;
	}

	public getLastUpdated(): Time {
		return this.last_updated;
	}

	public isDisabled(): boolean {
		return !this.enabled;
	}

	public getValidity(): number {
		return this.validity_remaining;
	}

	public getWalletId(): string {
		return this.wallet_id;
	}

	public disable(): void {
		this.enabled = false;
		this.address = "";
	}
}
